var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Cookies from "js-cookie";
var decodeInNodeJs = function (data) {
    return Buffer.from(data, "base64").toString("utf-8");
};
var REA_USER_INFO_COOKIE = "reauinf";
var REAUID_COOKIE = "reauid";
var getUserInfo = function (reauinf, decode) {
    try {
        var _a = JSON.parse(decode(reauinf)), lid = _a.lid, cid = _a.cid, isNewUser = _a.isNewUser;
        return {
            lockeId: lid,
            consumerId: cid,
            isNewUser: isNewUser,
        };
    }
    catch (_b) {
        return null;
    }
};
var createUser = function (cookies, decode) {
    var reauinf = cookies[REA_USER_INFO_COOKIE];
    var userId = { userId: cookies[REAUID_COOKIE] };
    if (reauinf) {
        var userInfo = getUserInfo(reauinf, decode);
        if (userInfo) {
            return __assign({ isSignedIn: true, isNewUser: userInfo.isNewUser, consumerId: userInfo.consumerId, lockeId: userInfo.lockeId }, userId);
        }
    }
    return __assign({ isSignedIn: false, isNewUser: false }, userId);
};
export var createBrowserUser = function (cookies) {
    if (cookies === void 0) { cookies = Cookies.get(); }
    return createUser(cookies, window.atob);
};
export var createServerUser = function (cookies) {
    return createUser(cookies, decodeInNodeJs);
};
export var createNullUser = function () { return ({
    isSignedIn: false,
    isNewUser: false,
}); };
//# sourceMappingURL=user.js.map